<template>
  <offer-sale-base :offer-sale="offerSale" :is-group="isGroup" type="next_buy_cashback_offer_sales" :is-activable="isActivable">
    <template v-slot:line-1>
      <offer-sale-line :line-items="isGroup ? cashbackItem : productInfoItems" />
    </template>

    <template v-slot:line-2>
      <offer-sale-line :line-items="isGroup ? minMaxItems : cashbackItem">
        <user-consumption v-if="isGroup" :maximum-per-client="offerSale.max_coupons" :user-sale-consumption-amount="userSaleConsumptionAmountInGroup" />
      </offer-sale-line>
    </template>

    <template v-if="!isGroup" v-slot:line-3>
      <offer-sale-line :line-items="minMaxItems">
        <user-consumption :maximum-per-client="offerSale.max_coupons" :user-sale-consumption-amount="offerSale.user_sale_consumption_amount" />
      </offer-sale-line>
    </template>
  </offer-sale-base>
</template>

<script>
import OfferSaleBase from './OfferSaleBase.vue'
import OfferSaleLine from './OfferSaleLine.vue'
import UserConsumption from './UserConsumption.vue'

export default {
  name: 'NextBuyCashbackOfferSale',
  components: {
    OfferSaleBase,
    OfferSaleLine,
    UserConsumption,
  },
  props: {
    offerSale: {
      type: Object,
      required: true,
    },
    isActivable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isGroup() {
      return this.offerSale.next_buy_cashback_offer_sales && this.offerSale.next_buy_cashback_offer_sales.length > 0
    },
    userSaleConsumptionAmountInGroup() {
      return this.offerSale.next_buy_cashback_offer_sales.reduce(
        (acc, nextbuycashbackOfferSale) => acc + nextbuycashbackOfferSale.user_sale_consumption_amount,
        0
      )
    },
    productInfoItems() {
      return [
        {
          label: 'SKU',
          value: this.offerSale.sku,
          format: 'text',
        },
        {
          label: 'EAN',
          value: this.offerSale.ean,
          format: 'text',
        },
      ]
    },
    cashbackItem() {
      return [
        {
          label: 'Cashback (R$)',
          value: this.offerSale.cashback_absolute_discount,
          format: 'currency',
        },
      ]
    },
    minMaxItems() {
      return [
        {
          label: 'Mín. CPF',
          value: this.offerSale.minimum_per_client,
          format: 'text',
        },
        {
          label: 'Máx. CPF',
          value: this.offerSale.max_coupons,
          format: 'text',
        },
      ]
    },
  },
}
</script>
